export const PageTemplate = {
  tag: 'main',
  flow: 'x',
  width: '100%',
  margin: '- auto',
  maxWidth: 'K_default',
  padding: 'D2 E B1',
  flex: 1,
  flow: 'column',
  '@screenS': {
    padding: 'C1 C B1',
  },
  '@tabletS': {
    padding: 'C1 B',
  },
};